export default __webpack_public_path__ + "static/media/banner-01.66e3867d.jpg";